<template>
  <transition name="fade">
    <div class="abtesting-wrapper" v-show="toShow">
      <div class="abtesting-wrapper__inner">
        <div class="abtesting-header">Check out these perks (while crushing your courses):</div>
        <div
          class="abtesting-box"
          :class="{'abtesting-full-width' : noNotifications}">
          <div class="abtesting-transfer-col">
            <div class="abtesting-certificate">
              <i class="fa-thin fa-file-certificate main-icon" />
              <i class="fa-solid fa-sparkles sparkle" />
              <i class="fa-solid fa-star sparkle" />
              <i class="fa-solid fa-sparkles sparkle" />
              <i class="fa-solid fa-star sparkle" />
              <i class="fa-solid fa-sparkles sparkle" />
            </div>
            <div class="abtesting-content">
              <div class="abtesting-title">Got questions on transfer credit?</div>
              <p class="abtesting-text">
                We're here to help! Check out our <strong>Transfer Credit Hub</strong> for tips or talk to a Transfer Navigator.
              </p>
              <div>
                <p>
                  <a href="/transfer-navigator" target="_blank">
                    Go to the Transfer Credit Hub <i class="fa-sharp fa-solid fa-arrow-right-long"></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="abtesting-separator">
            <i class="fa-thin fa-pipe"></i>
          </div>
          <div class="abtesting-pig-col">
            <sdn-banner :sdnData="sdnData" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SdnBanner from './sdn_notification_banner'

  export default {
    props: {
      sdnData: {
        type: Object
      }
    },
    data() {
      return {
        toShow: false
      }
    },
    components: {
      SdnBanner
    },
    computed: {
      ...mapGetters(['notifications']),
      noNotifications () {
        return this.notifications.length == 0
      }
    },
    mounted() {
      this.loadNotifications({ type: 'sdn', limit: 1, mark_read: false }).then(() => {
        this.toShow = true
      })
    },
    methods: {
      ...mapActions(['loadNotifications']),
    }
  }
</script>
